import Box from '@mui/material/Box'
import { ReactNode } from 'react'

interface Props {
  children: ReactNode
}

const Body = ({ children }: Props) => {
  return <Box sx={{ p: 3 }}>{children}</Box>
}

export default Body
